import { TypeCurveBase } from './base/type-curve-base';

export class TypeCurve extends TypeCurveBase { }